import { render, staticRenderFns } from "./tabber.vue?vue&type=template&id=05d8a504&scoped=true"
import script from "./tabber.vue?vue&type=script&lang=js"
export * from "./tabber.vue?vue&type=script&lang=js"
import style0 from "./tabber.vue?vue&type=style&index=0&id=05d8a504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8a504",
  null
  
)

export default component.exports